import React, { useState } from "react";
import PropTypes from "prop-types";
import {TypesHightPhoto} from "../constants/constants";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { UtilModal } from "../mascotas/util-modal";
import { validateThereUrl } from "../mascotas/util-functions";

const MESSAGE_DEFAULT = {};
const PhotosMascota = (props) => {
  let mobileQuery = useMediaQuery("(max-width:576px)");
  const [modal, setModal] = useState({
    open_modal: false,
    message: {},
    type_modal: "defaultModal",
    image: "",
    functions: {},
  });
  const [urlWithError, setUrlWithError] = useState(false);
  const eyeMascota = require("../img/eye-mascota.svg");
  const getHigthClass = (typeHightPhoto) => {
    switch (typeHightPhoto) {
      case TypesHightPhoto.mascota:
        return "photo_mascota_height";
      case TypesHightPhoto.cartilla:
        return "photo_cartilla_height";
      case TypesHightPhoto.noImageMascota:
        return "photo_mascota_height no_image_mascota_properties";
      default:
        return ""; // to show image with his own properties
    }
  };
  const close = () => {
    setModal({ ...modal, open_modal: false, image: props.url, functions: {} });
  };

  const handleClick = (img) => {
    setModal({
      ...modal,
      open_modal: true,
      message: MESSAGE_DEFAULT,
      image: img,
      functions: { onClose: close },
    });
  };
 
  const { type_modal, open_modal, message, image, functions } = modal;
  return (
    <div className="card_preview-photos">
      <div className="card_preview_container-photo">
        <img
          className={`card_preview-img-photos ${getHigthClass(props.hight)}`}
          src={props.url}
          alt={props.footerTitle}
         onError={(e)=>{setUrlWithError(true); e.target.onerror = null; e.target.src=`${validateThereUrl(undefined)}`; e.target.className=`card_preview-img-photos ${getHigthClass(TypesHightPhoto.noImageMascota)}`;}}
        />
      </div>
        <div className="card_preview-footer-photos">
          <span className="card_preview-title-photos">{props.footerTitle}</span>
          {(props.withFooter && !urlWithError) && ( 
                  <img
                    onClick={() => {
                      handleClick(props.url);
                    }}
                    src={eyeMascota}
                    alt="icon-question"
                  />
          )}
        </div>
      {UtilModal(
        {
          modal_text: {
            title_modal: props.footerTitle,
            textButtonConfirm: "Aceptar"
          },
          modal_properties: {
            type_modal,
            open_modal,
            image,
            mobileQuery,
            nameQuery: "mobileStyles",
          },
        },
        functions
      )}
    </div>
  );
};
PhotosMascota.propTypes = {
    url: PropTypes.string.isRequired,  
    footerTitle: PropTypes.string.isRequired,  
    hight: PropTypes.string.isRequired,
    withFooter: PropTypes.bool, 
}
PhotosMascota.defaultProps = {
    withFooter: true
}
export default PhotosMascota;



// WEBPACK FOOTER //
// ./src/home/photosMascota.js